import React from 'react';
import { NotFoundPage } from '../NotFoundPage/index.js';
export function NotFoundPageWrapper(props, language) {
    if (props.staticContext) {
        props.staticContext.statusCode = 404;
    }
    return (React.createElement(NotFoundPage, { language: language }));
}
